import React, { useContext } from 'react';
import { ReaderInterface } from '../../../../../../model/DeviceAdminModel';
import { DoorStoreSingleContext } from '../../../DoorModal/DoorStoreSingleContext';
import { StoreContext } from '../../contextReader';
import { AntiPassback, AssuranceLevels, CCOTZ, PassbackZones } from '../sections';
import styles from './logic.module.scss';

type Props = {
	setPreviousSelection: (number) => void;
	useDoorContext: boolean;
};

const Logic: React.FC<Props> = ({ setPreviousSelection, useDoorContext }) => {
	if (useDoorContext) {
		var {
			contextStateDoor: {
				entryReader: { isDoorWireless, readerInterface },
			},
		} = useContext(DoorStoreSingleContext);
	} else {
		var {
			readerState: { isDoorWireless, readerInterface },
		} = useContext(StoreContext);
	}

	return (
		<div id='logicReaderContainer' className={styles.form}>
			<PassbackZones useDoorContext={useDoorContext} />
			<AntiPassback useDoorContext={useDoorContext} />
			<CCOTZ setPreviousSelection={setPreviousSelection} useDoorContext={useDoorContext} />
			{!isDoorWireless && readerInterface === ReaderInterface.RS485 && <AssuranceLevels useDoorContext={useDoorContext} />}
		</div>
	);
};

export { Logic };
